import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const productApi = createApi({
    reducerPath: 'productApi',
    baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_BASE_URL }),
    endpoints: builder => ({
        getProductsByCategory: builder.query({
            query: category => `/api/products?category=${category}`,
        }),
        getAllProducts: builder.query({
            query: () => `/api/products`,
        }),
        getProductBySlug: builder.query({
            query: slug => `/api/products/${slug}`,
        }),
    }),
});

export const { useGetProductsByCategoryQuery, useGetAllProductsQuery, useGetProductBySlugQuery } =
    productApi;
